import {Stack, Typography} from '@mui/material';
import ModuleViewActionButton from './ModuleViewActionButton';

export interface ModuleViewActionsProps {
  onShuffleQuestions: () => void;
  onValidateAllQuestions: () => void;
  onValidateAllQuestionsGpt: () => void;
  onGenerateAllTopics: () => void;
  onGenerateWithSeedQuestion: () => void;
  onGenerateAllStudies: () => void;
  onCountQuestions: () => void;
  onBulkChangeStatus: () => void;
  shuffleLoading: boolean;
  validateLoading: boolean;
  validateGptLoading: boolean;
  generateAllLoading: boolean;
  generateWithSeedLoading: boolean;
  generateStudiesLoading: boolean;
  countLoading: boolean;
  bulkChangeLoading: boolean;
}

export default function ModuleViewActions({
  onShuffleQuestions,
  onValidateAllQuestions,
  onValidateAllQuestionsGpt,
  onGenerateAllTopics,
  onGenerateWithSeedQuestion,
  onGenerateAllStudies,
  onCountQuestions,
  onBulkChangeStatus,
  shuffleLoading,
  validateLoading,
  validateGptLoading,
  generateAllLoading,
  generateWithSeedLoading,
  generateStudiesLoading,
  countLoading,
  bulkChangeLoading,
}: ModuleViewActionsProps) {
  return (
    <Stack direction="column" spacing={3} sx={{flexWrap: 'wrap', alignItems: 'flex-start'}}>
      {/* Questions Actions */}
      <Stack spacing={1.5}>
        <Typography variant="subtitle2" sx={{color: '#1B263B', fontWeight: 600}}>
          Questions
        </Typography>
        <Stack direction="row" gap={1.5} sx={{flexWrap: 'wrap'}}>
          <ModuleViewActionButton
            label="Generate"
            onClick={onGenerateAllTopics}
            loading={generateAllLoading}
            bgcolor="#1B263B"
          />
          <ModuleViewActionButton
            label="Generate with seed question"
            onClick={onGenerateWithSeedQuestion}
            loading={generateWithSeedLoading}
            bgcolor="#1B263B"
          />
          <ModuleViewActionButton
            label="Validate"
            onClick={onValidateAllQuestions}
            loading={validateLoading}
            bgcolor="#90BE6D"
          />
          <ModuleViewActionButton
            label="Validate (GPT)"
            onClick={onValidateAllQuestionsGpt}
            loading={validateGptLoading}
            bgcolor="#90BE6D"
          />
          <ModuleViewActionButton
            label="Randomize"
            onClick={onShuffleQuestions}
            loading={shuffleLoading}
            bgcolor="#FF6F59"
          />
          <ModuleViewActionButton
            label="Count"
            onClick={onCountQuestions}
            loading={countLoading}
            bgcolor="#1B263B"
            variant="outlined"
            progressColor="#1B263B"
          />
          <ModuleViewActionButton
            label="Bulk Change Status"
            onClick={onBulkChangeStatus}
            loading={bulkChangeLoading}
            bgcolor="#1B263B"
            variant="outlined"
            progressColor="#1B263B"
          />
        </Stack>
      </Stack>

      {/* Study Actions */}
      <Stack spacing={1.5}>
        <Typography variant="subtitle2" sx={{color: '#1B263B', fontWeight: 600}}>
          Study
        </Typography>
        <Stack direction="row" spacing={1.5} sx={{flexWrap: 'wrap'}}>
          <ModuleViewActionButton
            label="Generate"
            onClick={onGenerateAllStudies}
            loading={generateStudiesLoading}
            bgcolor="#FF6F59"
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
